import { render } from "./revizeForm.vue?vue&type=template&id=3e805de8"
import script from "./revizeForm.vue?vue&type=script&lang=js"
export * from "./revizeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__